var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisplayMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 112.5",
    style: {
      enableBackground: "new 0 0 90 112.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.5,29.1h51.1c2.3,0,4.2,1.8,4.2,4.2v33.6c0,2.3-1.8,4.2-4.2,4.2H23.9c-0.6,0-1.1,0.2-1.4,0.7l-7.2,8.4V33.3 C15.3,30.9,17.1,29.1,19.5,29.1z M19.5,25.4c-4.4,0-8,3.6-8,7.9v52c0,1.8,2.2,2.6,3.3,1.2l10-11.7h45.7c4.4,0,8-3.6,8-7.9V33.3 c0-4.4-3.6-7.9-8-7.9H19.5L19.5,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.7,43.3c-1.1,0-1.9,0.8-1.9,1.9c0,1.1,0.9,1.9,1.9,1.9h42.6c1.1,0,1.9-0.8,1.9-1.9c0-1.1-0.9-1.9-1.9-1.9 H23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.7,55.4c-1.1,0-1.9,0.8-1.9,1.9c0,1.1,0.9,1.9,1.9,1.9h19.1c1.1,0,1.9-0.8,1.9-1.9c0-1.1-0.9-1.9-1.9-1.9 H23.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayMessage);
export default __webpack_public_path__ + "static/media/display_message.68a7cc2bd5e39d5c6df99188141ad64a.svg";
export { ForwardRef as ReactComponent };